






















import { Component, Vue } from 'vue-property-decorator';
import { BrandingInfo } from '../models/branding/branding';
import { vxm } from '../store.vuex';
@Component({
  name: 'CandidatePortalLogo',
  components: {},
})

// Workaround for Vue Store Branding Info Logo Bug!
export default class CandidatePortalLogo extends Vue {

  brandingImage(): string {
    let bLogo: any;
    if (sessionStorage) {
      bLogo = sessionStorage.getItem('brandingLogo');
      console.log('Using session storage', bLogo);
    } else {
      if (Vue.cookies.get('brandingLogo')) {
        bLogo = Vue.cookies.get('brandingLogo');
        console.log('Using cookies', bLogo);
      } else {
        bLogo = '../assets/images2/workLLama-logo.svg';
        console.log('Neither cookies nor session storage are available', bLogo);
      }
    }
    return bLogo;
  }
  isRedirection(): boolean {
    if (
      vxm.configs.getGlobalConfigValue(
        'CANDIDATE_PORTAL_COMPANY_LOGO_REDIRECTION_LINK',
      ).length == 0
    ) {
      return false;
    }
    return true;
  }
  get getLink() {
    if (
      vxm.configs.getGlobalConfigValue('LANDING_PAGE_BEFORE_SIGN_IN') === 'COMPANY_PROFILE' &&
      !vxm.users.isLoggedIn &&
      vxm.configs.getGlobalConfigValue(
        'CANDIDATE_PORTAL_COMPANY_LOGO_REDIRECTION_LINK',
      ).length == 0
    ) {
      return `/companyprofile/${vxm.jobs.BrandingInfo.companycode}`;
    } else {
      return vxm.configs.getGlobalConfigValue(
        'CANDIDATE_PORTAL_COMPANY_LOGO_REDIRECTION_LINK',
      );
    }
  }
}
